(() => {
  const initializeAuthorIndex = (scope = document) => {
    scope.querySelectorAll('[data-author-index]').forEach((index) => {
      if (index.dataset.authorIndexReady === 'true') return;
      index.dataset.authorIndexReady = 'true';

      const requestedLetter = new URLSearchParams(window.location.search).get('letra');
      if (!requestedLetter) return;

      const letter = requestedLetter.toLocaleLowerCase('es').replace(/[^a-z0-9-]/g, '');
      const template = index.querySelector(`[data-author-letter-template="${letter}"]`);
      const detail = index.querySelector('[data-author-letter-page]');
      const results = index.querySelector('[data-author-letter-results]');
      if (!template || !detail || !results) return;

      const grid = index.querySelector('[data-author-index-grid]');
      const title = index.querySelector('[data-author-index-title]');
      const detailTitle = index.querySelector('[data-author-letter-title]');

      results.replaceChildren(template.content.cloneNode(true));
      if (grid) grid.hidden = true;
      if (title) title.hidden = true;
      detail.hidden = false;

      const visibleLetter = letter === 'otros' ? 'Otros' : letter.toLocaleUpperCase('es');
      if (detailTitle) detailTitle.textContent = `Autores con ${visibleLetter}`;

      index.querySelectorAll('[data-author-letter-link]').forEach((link) => {
        if (link.dataset.authorLetterLink === letter) {
          link.setAttribute('aria-current', 'page');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAuthorIndex());
  } else {
    initializeAuthorIndex();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAuthorIndex(event.target));
})();
